import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { User, UserCurrentResp, UserPermissionType, UserRoleType } from 'app/core/shared/types/user.type';
import { map, Observable, ReplaySubject, tap } from 'rxjs';
import { ResponseResult } from 'app/core/shared/shared.type';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class UserService {
  private _user: ReplaySubject<User> = new ReplaySubject<User>(1);
  private _userWithCompany: ReplaySubject<UserCurrentResp> = new ReplaySubject<UserCurrentResp>(1);
  spaceRouteClone: ReplaySubject<FuseNavigationItem[]> = new ReplaySubject<FuseNavigationItem[]>(1);

  /**
   * Constructor
   */
  constructor(private _httpClient: HttpClient) {
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Setter & getter for user
   *
   * @param value
   */
  set user(value: User) {
    // Store the value
    this._user.next(value);
  }

  get user$(): Observable<User> {
    return this._user.asObservable();
  }

  get roles$(): Observable<string[]> {
    return this._user.pipe(map(user => user.roles));
  }

  get perrmissions$(): Observable<UserPermissionType[]> {
    return this._user.pipe(map(user => user.permissions));
  }


  /**
   * Setter & getter for user
   *
   * @param value
   */
  set userWithCompany(value: UserCurrentResp) {
    // Store the value
    this._userWithCompany.next(value);
  }

  get userWithCompany$(): Observable<UserCurrentResp> {
    return this._userWithCompany.asObservable();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Get the current logged in user with company data
   */
  getCurrentUser(): Observable<ResponseResult<UserCurrentResp>> {
    return this._httpClient.get<ResponseResult<UserCurrentResp>>(`${environment.apiURL}/${environment.apiVersion}/Account/GetCurrentUser`).pipe(
    // return this._httpClient.get<ResponseResult<UserCurrentResp>>(`${environment.apiURL}/${environment.apiVersion}/Users/Current`).pipe(
      tap((resp: ResponseResult<UserCurrentResp>) => {
        this._userWithCompany.next(resp.data);
      }),
    );
  }

  /**
   * Update the user
   *
   * @param user
   */
  update(user: User): Observable<any> {
    return this._httpClient.patch<User>('api/common/user', { user }).pipe(
      map((response) => {
        this._user.next(response);
      }),
    );
  }
}
